import "@fontsource/source-sans-pro";

export const fontFamily = {
  sourceSansPro: "Source Sans Pro",
};
